'use client';

interface EnvironmentBarProps {
	text?: string;
	className?: string;
}

export const EnvironmentBar = ({ text = 'DEVELOPMENT', className = '' }: EnvironmentBarProps) => {
	return (
		<div className={`flex w-full justify-center bg-error-600 ${className}`}>
			<div className="flex w-full justify-center">
				<p className="m-0 text-sm leading-5 text-white">{text}</p>
			</div>
		</div>
	);
};
